import React from "react";
import { View, Text } from "react-native";
import { AppColors } from "../../utility/AppColors";

import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import Skeletons from "../../Components/skeleton-components/Skeletons";

const ChangeAvatarSkeleton = ({}) => {
  const deviceSize = useDeviceSize();
  let skeletonCards = Array(3).fill(0);
  let games = Array(10).fill(0);
  return (
    <View
      style={{
        flex: 1,
        backgroundColor: "transparent",
        padding: 20,
      }}
    >
      {/* Title */}
      <Skeletons
        height={36}
        width={"200px"}
        style={{ borderRadius: 6, marginBottom: 10 }}
        backgroundColor={AppColors.gray_C4C4C4}
      />
      <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
        {/* Subtitle */}
        <Skeletons
          height={18}
          width={"100px"}
          style={{ borderRadius: 6, marginBottom: 20 }}
          backgroundColor={AppColors.gray_C4C4C4}
        />
        {/* Buttons */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "flex-end",
            marginTop: 20,
            gap: 10,
          }}
        >
          <Skeletons
            height={40}
            width={"100px"}
            style={{ borderRadius: 20 }}
            backgroundColor={AppColors.gray_C4C4C4}
          />
          <Skeletons
            height={40}
            width={"100px"}
            style={{ borderRadius: 20 }}
            backgroundColor={AppColors.gray_C4C4C4}
          />
        </View>
      </View>
      {/* Avatar Look Section */}
      <View
        style={{
          flexDirection: "row",
          gap: 20,
          justifyContent: "center",
          marginBottom: 20,
        }}
      >
        {["Head", "Upper Body", "Full Body"].map((label, index) => (
          <View key={index} style={{ alignItems: "center" }}>
            <Skeletons
              height={181}
              width={"181px"}
              style={{ borderRadius: 10, marginBottom: 5 }}
              backgroundColor={AppColors.gray_C4C4C4}
            />
            <Skeletons
              height={12}
              width={"60px"}
              style={{ borderRadius: 6 }}
              backgroundColor={AppColors.gray_C4C4C4}
            />
          </View>
        ))}
      </View>
      {/* Avatar Grid */}
      {skeletonCards.map((_, index) => (
        <View
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          {games.map((_, index) => (
            <Skeletons
              key={index}
              height={130}
              width={"100px"}
              style={{ borderRadius: 10, marginBottom: 10, marginRight: 30 }}
              backgroundColor={AppColors.gray_C4C4C4}
            />
          ))}
          {/* {[...Array(10)].map((_, index) => (
          <Skeletons
            key={index}
            height={130}
            width={"100px"}
            style={{ borderRadius: 10, marginBottom: 10 }}
            backgroundColor={AppColors.gray_C4C4C4}
          />
        ))}
        {[...Array(10)].map((_, index) => (
          <Skeletons
            key={index}
            height={130}
            width={"100px"}
            style={{ borderRadius: 10, marginBottom: 10 }}
            backgroundColor={AppColors.gray_C4C4C4}
          />
        ))} */}
        </View>
      ))}
    </View>
  );
};

export default ChangeAvatarSkeleton;
